interface IntegrationLogoProps {
  src: string | string[]; // Support single or multiple images (like Canva)
  alt: string;
  height?: string;
  label?: string;
  labelFont?: string;
  className?: string;
  additionalClasses?: string; // For special cases like invert
}

export const IntegrationLogo = ({
  src,
  alt,
  height = "h-12",
  label,
  labelFont,
  className = "",
  additionalClasses = ""
}: IntegrationLogoProps) => {
  const images = Array.isArray(src) ? src : [src];

  // Base classes for hover effect
  const baseClasses = "opacity-60 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-300";

  // If label is provided, wrap in flex container
  if (label) {
    return (
      <div className={`flex items-center gap-2 sm:gap-3 ${baseClasses} ${className}`}>
        {images.map((imgSrc, index) => (
          <img
            key={index}
            src={imgSrc}
            alt={alt}
            className={`${height} w-auto ${additionalClasses}`}
          />
        ))}
        <span
          className="text-sm sm:text-2xl font-light text-muted-foreground whitespace-nowrap"
          style={labelFont ? { fontFamily: labelFont } : undefined}
        >
          {label}
        </span>
      </div>
    );
  }

  // No label - direct image(s)
  if (images.length === 1) {
    return (
      <img
        src={images[0]}
        alt={alt}
        className={`${height} w-auto ${baseClasses} ${additionalClasses} ${className}`}
      />
    );
  }

  // Multiple images (like Canva) without label
  return (
    <div className={`flex items-center gap-2 sm:gap-3 ${baseClasses} ${className}`}>
      {images.map((imgSrc, index) => (
        <img
          key={index}
          src={imgSrc}
          alt={alt}
          className={`${height} w-auto ${additionalClasses}`}
        />
      ))}
    </div>
  );
};
